import { Component, OnChanges, model, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconComponent } from 'app/modules/shared/svg-icon/svg-icon.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

interface HistoryFilter {
  version: string;
  active: boolean;
}

@Component({
  selector: 'app-project-version-history-dropdown-menu',
  templateUrl: './project-version-history-dropdown-menu.component.html',
  imports: [
    SvgIconComponent,
    BsDropdownModule,
    TranslateModule,
  ],
  styleUrls: ['./project-version-history-dropdown-menu.component.scss']
})
export class ProjectVersionHistoryDropdownMenuComponent implements OnChanges {

  public historyVersion = input<Set<string>>(new Set<string>());

  public filterEmitter = output<string>();

  public selectedFilter = model<string | undefined>(undefined);

  historyFilter: HistoryFilter[] = [];

  ngOnChanges() {
    const historyFilter: HistoryFilter[] = [];
    this.historyVersion().forEach(version => {
      historyFilter.push({
        version: version,
        active: this.selectedFilter() === version
      });
    });
    this.historyFilter = historyFilter;
  }

  public changeActiveFilter(newFilter: string) {
    this.historyFilter.forEach(entry => {
      entry.active = entry.version === newFilter ? true : false;
    });
    this.selectedFilter.set(newFilter);
    this.filterEmitter.emit(newFilter);
  }
}
